import React, {
  useEffect,
  useState
} from "react";

import {
  Box,
  Typography
} from "@mui/material";

export default function CountdownTimer({
  initialSeconds = 120,
  recording,
  paused
}) {

  const [seconds, setSeconds] =
    useState(initialSeconds);

  // =========================================
  // RESET TIMER ON RECORD START
  // =========================================

  useEffect(() => {

    if (recording) {
      setSeconds(initialSeconds);
    }

  }, [recording, initialSeconds]);

  // =========================================
  // COUNTDOWN
  // =========================================

  useEffect(() => {

    if (!recording || paused) return;

    const timer =
      setInterval(() => {

        setSeconds(prev => {

          if (prev <= 1) {

            clearInterval(timer);

            return 0;
          }

          return prev - 1;
        });

      }, 1000);

    return () =>
      clearInterval(timer);

  }, [recording, paused]);

  // HIDE WHEN NOT RECORDING
  if (!recording) return null;

  // =========================================
  // FORMAT MM:SS
  // =========================================

  const mins =
    Math.floor(seconds / 60);

  const secs =
    seconds % 60;

  const formatted =
    `${mins}:${secs
      .toString()
      .padStart(2, "0")}`;

  // =========================================
  // CIRCLE PROGRESS
  // =========================================

  const progress =
    ((initialSeconds - seconds) / initialSeconds) * 100;

  const radius = 24;

  const circumference =
    2 * Math.PI * radius;

  const offset =
    circumference -
    (progress / 100) * circumference;

  // =========================================
  // UI
  // =========================================

  return (
    <Box
      sx={{
        position: "relative",

        width: 58,
        height: 58,

        display: "flex",

        alignItems: "center",
        justifyContent: "center",

        userSelect: "none",
      }}
    >

      {/* SVG PROGRESS */}
      <svg
        width="58"
        height="58"
        style={{
          position: "absolute",

          transform: "rotate(-90deg)",
        }}
      >

        {/* WHITE BASE */}
        <circle
          cx="29"
          cy="29"
          r={radius}

          stroke="rgba(255,255,255,0.25)"

          strokeWidth="4"

          fill="transparent"
        />

        {/* RED PROGRESS */}
        <circle
          cx="29"
          cy="29"
          r={radius}

          stroke={paused ? "#ffc107" : "#ff3b30"}

          strokeWidth="4"

          fill="transparent"

          strokeLinecap="round"

          strokeDasharray={circumference}

          strokeDashoffset={offset}

          style={{
            transition:
              paused
                ? "none"
                : "stroke-dashoffset 1s linear",
          }}
        />
      </svg>

      {/* TIMER TEXT */}
      <Typography
        sx={{
          color: "#fff",

          fontSize: 11,

          fontWeight: 600,

          textAlign: "center",

          textShadow:
            "0 2px 8px rgba(0,0,0,0.25)",
        }}
      >
        {formatted}
      </Typography>

    </Box>
  );
}